var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.5303 8.46966L10.2803 3.21966C9.98738 2.92678 9.51263 2.92678 9.21975 3.21966C8.92688 3.51253 8.92688 3.98728 9.21975 4.28016L13.1895 8.24991H3C2.586 8.24991 2.25 8.58591 2.25 8.99991C2.25 9.41391 2.586 9.74991 3 9.74991H13.1895L9.21975 13.7197C8.92688 14.0125 8.92688 14.4873 9.21975 14.7802C9.36638 14.9268 9.558 14.9999 9.75 14.9999C9.942 14.9999 10.1336 14.9268 10.2803 14.7802L15.5303 9.53016C15.8231 9.23728 15.8231 8.76253 15.5303 8.46966Z","fill":"white"}));
}

ArrowRight.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
